<template lang="pug">
	.user-access(v-if="showed && user")
		.close-overlay(@click="hide()")
		.card
			.card-header
				i.fa.fa-edit
				span User Access
				.entity-id User Id: {{user.id}}
			.card-body.collapse.show
				.form-line
					label.col-form-label.controls-title {{ Metadata.AccessByCodename["banner-templates-edit"].title }}
					.controls
						label.switch.switch-label.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
							input.switch-input.form-check-input(type="checkbox" :checked="!!user.options.access?.['banner-templates-edit']" @change="toggleBooleanAccess('banner-templates-edit', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
				.form-line
					label.col-form-label.controls-title {{ Metadata.AccessByCodename["storyboard-templates-edit"].title }}
					.controls
						label.switch.switch-label.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
							input.switch-input.form-check-input(type="checkbox" :checked="!!user.options.access?.['storyboard-templates-edit']" @change="toggleBooleanAccess('storyboard-templates-edit', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
				.form-line
					label.col-form-label.controls-title {{ Metadata.AccessByCodename["playable-templates-edit"].title }}
					.controls
						label.switch.switch-label.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
							input.switch-input.form-check-input(type="checkbox" :checked="!!user.options.access?.['playable-templates-edit']" @change="toggleBooleanAccess('playable-templates-edit', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
				.form-line
					label.col-form-label.controls-title {{ Metadata.AccessByCodename["customer-contacts"].title }}
					.controls
						label.switch.switch-label.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
							input.switch-input.form-check-input(type="checkbox" :checked="!!user.options.access?.['customer-contacts']" @change="toggleBooleanAccess('customer-contacts', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
				.form-line.separator
					label.col-form-label.controls-title {{ Metadata.AccessByCodename["clone-project-repository"].title }}
					.controls
						label.switch.switch-label.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
							input.switch-input.form-check-input(type="checkbox" :checked="!!user.options.access?.['clone-project-repository']" @change="toggleBooleanAccess('clone-project-repository', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
				.form-actions
					button.btn.btn-dark(type="button" @click="hide()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';

	import { User } 			from '../../services/User';
	import { Creative } 			from '../../services/Creative';
	import { Version } 			from '../../services/Version';
	import { Settings } 		from '../../services/Settings';

	export default {
		name: "UserAccess",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Current User Changed: [options.access]"
			],
			events: {
				"Show UserAccess": function(userId) {

					this.userId = userId;

					this.update();

				}
			}
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.user = null;

			return {
				isUploading: false
			}
		},
		methods: {
			collectData() {

				this.user = User.getUser(this.userId);
				if (!this.user) return;

			},
			toggleBooleanAccess(accessCodename, checked) {

				Server.sendToSocket({
					SetUserAccess: {
						userId: this.user.id,
						accessCodename: accessCodename,
						accessValue: checked
					}
				});

			}
		}
	}
</script>


<style lang="sass">

	.user-access
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.close-overlay
			display: flex
			position: absolute
			z-index: 1
			left: 0
			top: 0
			right: 0
			bottom: 0

		.entity-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 500px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			z-index: 5

			.btn-danger, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.controls-title
				padding-left: 2px
				padding-bottom: 0
				margin-bottom: 5px

		.form-group
			display: flex
			flex-direction: column
			margin-left: 40px

			&:first-child
				margin-left: 0

			&.bottom-align
				align-self: flex-end

		.form-line
			display: flex
			flex-direction: row
			justify-content: space-between

		.form-actions
			margin-top: 20px

</style>

